import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useTiktokTagsAnalyticsFilter } from './hooks';

export interface TiktokTagsAnalyticsFilterProps extends Omit<TemplateProps, 'countryId'> {
  className?: string;
}

export const TiktokTagsAnalyticsFilter = ({ className, ...templateProps }: TiktokTagsAnalyticsFilterProps) => {
  const { filter, setFilterForm, countryId } = useTiktokTagsAnalyticsFilter();

  return (
    <Filter.Provider values={filter} onSubmit={setFilterForm} className="hashtag-filter-container">
      <Template {...templateProps} countryId={countryId} />
    </Filter.Provider>
  );
};

export * from './schemaTypes';
export { useTiktokTagsAnalyticsFilter };
